<template>
  <v-container fill-height fluid class="blue">
      <v-col xs='12' sm='12' md="12">
        <div style="text-align: center">
          <img style="width: 260px; margin-bottom: 40px;" src="@/assets/logo-reg.png" />
        </div>
        <v-row wrap>
          <v-col xs="10" offset-xs="1" sm="10" offset-sm="1" md="8" offset-md="2">
            <v-card>
              <v-card-title class="primary">
                <h4 class="reg__heading">Set Password</h4>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-form>
                  <v-text-field
                    v-model="newPassword"
                    label="Enter New Password"
                    prepend-icon="lock"
                    required
                    :append-icon="visible ? 'visibility' : 'visibility_off'"
                    @click:append="() => (visible = !visible)"
                    :type="visible ? 'text' : 'password'"
                    v-bind:rules="passwordRules"
                    ref="resetPassword"
                  >
                  </v-text-field>
                  
                </v-form>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" class="white--text" @click="resetPassword">Set</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    

    <v-dialog v-model="loaderDialog" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Please stand by
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="loginErrorDialog" hide-overlay persistent width="300">
      <v-card>
        <v-card-text>
          <v-alert :value="true" color="error" icon="warning" outline>
            Error occured.Please try again.
          </v-alert>
          <div class="text-xs-center">
            <v-btn
              color="red"
              class="white--text"
              :disabled="!valid"
              @click.native="loginErrorDialog = false"
              >Close</v-btn
            >
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      newPassword: "",
      visible: "",
      loaderDialog: false,
      loginErrorDialog: false,
      passwordRules: [v => /^[A-Za-z0-9\d\S\-]*$/.test(v) || "Please enter a valid Password"]
    };
  },
  computed: {},
  watch: {},
  created() {},
  methods: {
    resetPassword(e) {
      if (this.newPassword == "") {
        this.$swal({
          type: "error",
          text: "Please provide a password"
        });
        return;
      }

      if (this.$refs.resetPassword.validate() == false) {
       
        this.$swal({
          type: "error",
          text: "Please provide a valid password"
        });
      } else {
       
        const self = this;

        self.loaderDialog = true;
        
        self.$http
          .post(
            `${this.$store.state.endpoint}Accounts/reset-password?access_token=${self.$route.query.token}`,
            { newPassword: self.newPassword, confirmPassword: self.confirmPassword }
          )
          .then(
            response => {
              self.loaderDialog = false;
              self.$router.replace({ path: "/" });
            },
            error => {
              self.loaderDialog = false;
              // self.loginErrorDialog = true
            }
          );
      }
    }
  }
};
</script>

<style>

.v-card {
  box-shadow: 0 2px 1px -1px rgba(0, 0, 0, 0), 0 1px 1px 0 rgba(0, 0, 0, 0),
    0 1px 3px 0 rgba(0, 0, 0, 0);
}


</style>
